import React, { useEffect, useRef, useState } from 'react';
import './CircleMenu.css';

const CircleMenu = ({
  items,
  isActiveCircleMenu, // используется только на самом верхнем уровне
  menuId,
  handleMenuItemClick,
  handleSubMenuItemClick,
  level = 0,
  sizeScale = 1.5,
}) => {
  const [isOpen, setIsOpen] = useState(isActiveCircleMenu === menuId);
  const [openSubMenus, setOpenSubMenus] = useState({});

  const isTopLevel = level === 0;

  const toggleMenu = () => setIsOpen((prev) => !prev);

  const toggleSubMenu = (index) => {
    setOpenSubMenus((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const sizeMultiplier = 1 - level * 0.2;
  const distanceBase = 100 * sizeMultiplier;

  const prevItemsRef = useRef([]);

  useEffect(() => {
    setIsOpen(isActiveCircleMenu === menuId);
  }, [isActiveCircleMenu, menuId]);

  useEffect(() => {
    const prevItems = prevItemsRef.current;
    // toggleMenu();
    if (prevItems.length > 0) {
      // сравниваем элементы
      items.forEach((item, index) => {
        if (item !== prevItems[index]) {
          toggleSubMenu(index);
        }
      });
    }

    // сохраняем текущие items для следующего сравнения
    prevItemsRef.current = items;
  }, [items]);
  return (
    <div
      className='circle-menu-container'
      style={{
        width: `${250 * sizeMultiplier}px`,
        height: `${250 * sizeMultiplier}px`,
      }}
    >
      {isTopLevel && (
        <div className='circle-menu-center' onClick={toggleMenu}>
          <span>{isOpen ? '×' : '+'}</span>
        </div>
      )}

      <div className={`circle-menu ${isOpen ? 'open' : ''}`}>
        {items.map((item, index) => {
          const angle = (360 / items.length) * index;
          const distance = distanceBase + items.length * 3;

          const hasSubItems = item.subItems && item.subItems.length > 0;

          return (
            <div
              key={index}
              className={`circle-menu-item ${level === 1 ? 'bottomLevel' : 'topLevel'
                } ${item.authStatus ? 'glow-effect' : ''}`}
              style={{
                transform: `rotate(${angle}deg) translate(${distance}px) rotate(-${angle}deg) `,
                transitionDelay: `${index * 0.1}s`,
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (hasSubItems) {
                  toggleSubMenu(index);
                } else {
                  handleMenuItemClick(item);
                }
              }}
            >
              <div className='circle-menu-icon'>
                {item.icon}
                {/* SVG с текстом вокруг */}
                <svg className='circle-label' viewBox='0 0 140 140'>
                  <defs>
                    <path
                      id={`circlePath-${index}`}
                      d='M70,70 m-55,0 a55,55 0 1,1 110,0 a55,55 0 1,1 -110,0'
                    />
                  </defs>
                  <text fontSize='20' fill='aliceblue' fontWeight='400'>
                    <textPath
                      href={`#circlePath-${index}`}
                      startOffset='50%'
                      textAnchor='middle'
                    >
                      {item.label}
                    </textPath>
                  </text>
                </svg>
              </div>

              {hasSubItems && (
                <div
                  className={`sub-menu-wrapper  ${openSubMenus[index] ? 'visible' : ''
                    }`}
                  style={{
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    transform: `translate(-50%, -50%) scale(0.65)`,
                  }}
                >
                  <CircleMenu
                    items={item.subItems}
                    handleMenuItemClick={handleSubMenuItemClick}
                    level={level + 1}
                    menuId={'subMenu-2'}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CircleMenu;
